export var getBillIdKey = function (id) { return "_" + id; };
